module.exports = Object.freeze({
    USER_POLICY_STATE_ACCEPT	: "PS01",				// 사용자 이용 약관 상태(동의)
    USER_POLICY_STATE_DENY		: "PS02",				// 사용자 이용 약관 상태(비 동의)
});